module.exports = __webpack_public_path__ + "static/media/DBS.568f035d.svg";